import React from 'react';

/**
 * Choix exclusif, au motif des cartes de « Gestion des paiements » : bordure et
 * fond #246990 a la selection, pastille dessinee.
 *
 * Remplace les `input type="radio"` natifs, qui juraient avec le reste de
 * l'application. Partage entre l'inscription, la reinscription et l'etape
 * « famille nombreuse » pour que les trois parcours proposent le meme geste.
 */
const CarteChoix = ({ actif, onClick, titre, description, disabled = false, children }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-pressed={actif}
    className={`w-full text-left rounded-lg border px-3 py-2.5 transition-all ${disabled
      ? 'border-gray-200 bg-gray-50 cursor-not-allowed opacity-60'
      : actif
        ? 'border-[#246990] bg-white shadow-sm'
        : 'border-gray-200 bg-white/70 hover:border-[#246990]/40 hover:bg-white'
      }`}
  >
    <span className="flex items-start gap-2.5">
      <span
        className={`mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border-2 ${actif ? 'border-[#246990]' : 'border-gray-300'
          }`}
      >
        {actif && <span className="h-2 w-2 rounded-full bg-[#246990]" />}
      </span>
      <span className="min-w-0 flex-1">
        <span className={`block text-sm font-semibold ${actif ? 'text-[#246990]' : 'text-gray-800'}`}>{titre}</span>
        {description && (
          <span className="mt-0.5 block text-[11px] leading-snug text-gray-600">{description}</span>
        )}
        {children}
      </span>
    </span>
  </button>
);

export default CarteChoix;
